import NewButton from "./NewButton";
import React from "react";
import { ReactComponent as NODATA } from "../assets/icons/no-data.svg";
import { ReactComponent as NOORDER } from "../assets/icons/no-order.svg";

const NoData = ({ title, text, btnText ="", onClick = () => {}, type ="quote", showBtn= true, loading= false, loadingText }) => {
  return (
    <div className="noDataWrap">
      {(type === "quote" || type === "notifications") ? <NODATA /> : <NOORDER/>}
      {!loading ? <div>
        <h4 className="noDataTitle">{title}</h4>
        {text && <p className="noDataText">{text}</p>}
      </div> : <h4 className="noDataTitle">Loading {loadingText}, Please wait<span className="dotsLoading">...</span></h4>}
      {showBtn && <NewButton className="mt-2" text={btnText} onClick={onClick} width="150px" />}
    </div>
  );
};

export default NoData;
